import React, { useEffect, useState } from "react";

// @material-ui/core components
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

// @material-ui/icons components
import Edit from "@material-ui/icons/Edit";
// core components
import Header from "../../components/Headers/Header.js";
import componentStyles from "../../assets/theme/views/admin/tables.js";
import { withAppContext } from "../../contextApi/Auth/index.js";
import axios from "axios";
import "sweetalert2/src/sweetalert2.scss";
import { BACKEND_URL, BACKENDImage_URL } from "../../env.js";

const useStyles = makeStyles(componentStyles);

const Subscription = () => {
    const classes = useStyles();
    const [AllSubscriptions, setAllSubscriptions] = useState([]);
    const [statusOptions] = useState(['pending', 'approve', 'reject']); // Update with your status options
    const [openImageDialog, setOpenImageDialog] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
        setOpenImageDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenImageDialog(false);
        setSelectedImage("");
    };
    const GetAllReward = () => {
        axios
            .get(`${BACKEND_URL}/subscription`, {
                headers: {
                    token: localStorage.getItem("Token"),
                },
            })
            .then((res) => {
                console.log(res.data, "subscription");
                setAllSubscriptions(res?.data?.getAllSubscribes);
            })
            .catch((err) => console.log(err));
    };
    useEffect(() => {

        GetAllReward();
    }, []);

    const handleStatusChange = (subscriptionId, newStatus) => {
        axios
            .put(
                `${BACKEND_URL}/subscription/status/${subscriptionId}`,
                { status: newStatus },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                // Update the state with the new status
                GetAllReward()
            })
            .catch((err) => console.log(err));
    };

    return (
        <>
            <Header />
            {/* Page content */}
            <Container
                maxWidth={false}
                component={Box}
                marginTop="-6rem"
                classes={{ root: classes.containerRoot }}
            >
                <Card classes={{ root: classes.cardRoot }}>
                    <CardHeader
                        className={classes.cardHeader}
                        title="Available Subscription"
                        titleTypographyProps={{
                            component: Box,
                            marginBottom: "0!important",
                            variant: "h3"
                        }}
                    />
                    {AllSubscriptions && AllSubscriptions.length >= 1 ? (
                        <TableContainer>
                            <Box component={Table} alignItems="center" marginBottom="0!important">
                                <TableHead>
                                    <TableRow>
                                        <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellRootHead }}>
                                            Store Name
                                        </TableCell>
                                        <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellRootHead }}>
                                            Email
                                        </TableCell>
                                        <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellRootHead }}>
                                            Whatsapp
                                        </TableCell>
                                        <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellRootHead }}>
                                            User Name
                                        </TableCell>
                                        <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellRootHead }}>
                                            Image
                                        </TableCell>

                                        <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellRootHead }}>
                                            Status
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {AllSubscriptions.map((subscription) => (
                                        <TableRow key={subscription.id}>

                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                <Box paddingTop=".35rem" paddingBottom=".35rem">{subscription.storeName}</Box>
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                <Box paddingTop=".35rem" paddingBottom=".35rem">{subscription.email}</Box>
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                <Box paddingTop=".35rem" paddingBottom=".35rem">{subscription.WhatsappNumber}</Box>
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                <Box paddingTop=".35rem" paddingBottom=".35rem">{subscription.UserName}</Box>
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                <img src={
                                                    subscription.Image?.startsWith("subscribe/http") || subscription.Image?.startsWith("subscribe/https")
                                                        ? subscription.Image.replace("subscribe/", "")
                                                        : `${BACKENDImage_URL}${subscription.Image}`
                                                }
                                                    width={40}
                                                    height={40}
                                                    style={{ borderRadius: "5px", cursor: "pointer" }} onClick={() =>
                                                        handleImageClick(
                                                            subscription.Image?.startsWith("subscribe/http") || subscription.Image?.startsWith("subscribe/https")
                                                                ? subscription.Image.replace("subscribe/", "")
                                                                : `${BACKENDImage_URL}${subscription.Image}`
                                                        )
                                                    } />
                                                {/* <Box paddingTop=".35rem" paddingBottom=".35rem">{subscription.accountNumber}</Box> */}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                <Select
                                                    value={subscription.status}
                                                    onChange={(e) => handleStatusChange(subscription.id, e.target.value)}
                                                    variant="outlined"
                                                    fullWidth
                                                >
                                                    {statusOptions.map((status) => (
                                                        <MenuItem key={status} value={status}>
                                                            {status}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Box>
                        </TableContainer>
                    ) : (
                        <div style={{ width: "100%", display: "flex", alignContent: "center", alignItems: "center", justifyContent: "center" }}>
                            <h1>No Subscription to Show</h1>
                        </div>
                    )}
                    <Dialog open={openImageDialog} onClose={handleCloseDialog} maxWidth="md">
                        <DialogContent>
                            <img src={selectedImage} alt="Full view" style={{ width: "100%", height: "auto" }} />
                        </DialogContent>
                    </Dialog>

                    {/* <Box classes={{ root: classes.cardActionsRoot }} component={CardActions} justifyContent="flex-end">
                        <Pagination count={3} color="primary" variant="outlined" />
                    </Box> */}
                </Card>
            </Container>
        </>
    );
};

export default withAppContext(Subscription);
